import React from "react";
import { BrowserRouter as Router } from "react-router-dom";

import { ToastProvider } from "../components";
import { SWRClient } from "../components/swr_client";
import { dictionaryEN } from "../locale/en";
import { dictionaryHE } from "../locale/he";
import { dictionaryES } from "../locale/es";
import { I18nProvider } from "../lib/i18n/i18n_provider";

import { SentryProvider } from "./sentry";
import { SplitIOProvider } from "./splitio";
import { enLocale } from "../offering/locale_data";
import { ConfigProvider } from "./config";
import { dictionaryPL } from "../locale/pl";

interface AppProviderProps {
  children?: React.ReactNode;
}

export function AppProvider(props: AppProviderProps) {
  const { children } = props;

  return (
    <Router>
      <ConfigProvider>
        <SentryProvider>
          <SplitIOProvider>
            <I18nProvider
              fallbackLocale={enLocale}
              initialDictionary={{
                en: dictionaryEN,
                "en-US": dictionaryEN,
                he: dictionaryHE,
                "he-IL": dictionaryHE,
                pl: dictionaryPL,
                "pl-PL": dictionaryPL,
                es: dictionaryES,
                "es-ES": dictionaryES,
              }}
            >
              <ToastProvider>
                <SWRClient>{children}</SWRClient>
              </ToastProvider>
            </I18nProvider>
          </SplitIOProvider>
        </SentryProvider>
      </ConfigProvider>
    </Router>
  );
}
